import {
    IMPORT_RATEQUOTE_LIST,
    IMPORT_RATEQUOTE_PAGINATION,
    IMPORT_RATEQUOTE_SUMMARY,
} from './constant';

export const initStateFeed = {
    rateQuoteList: [],
    pagination: {},
    summary: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case IMPORT_RATEQUOTE_LIST: {
            return {
                ...state,
                rateQuoteList: action.payload,
            };
        }
        case IMPORT_RATEQUOTE_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        case IMPORT_RATEQUOTE_SUMMARY: {
            return {
                ...state,
                summary: action.payload,
            };
        }
        default:
            return state;
    }
};
